/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, June 2020
 */


import React from 'react';
import html2canvas from 'html2canvas';
import GrayPanel from '../../components/GrayPanel';
import { PanelStyle } from '../../constants';
import v from '../../routes/eservices/validators';
import ModalAlert from '../../routes/eservices/ModalAlert';
import waiting from '../../routes/eserviceSummary/waiting-wheel-300x300.gif';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import font from './times_new_roman-normal';

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const {
  labelCol,
  inputCol,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const isBrowser = typeof window !== 'undefined' && window !== null;
let JsPDF;

if (isBrowser) {
  JsPDF = require('jspdf');
}

class MapToPDF extends React.Component {
  state = {
    title: 'Załącznik do wniosku - oznaczenie drzew i krzewów',
    errors: {},
    loading: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  };

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });

    if (this.props.title) {
      const title = this.props.title;
      this.setState({ title });
    }
  }

  onChange = (e) => {
    this.setState(
      {
        title: e.target.value,
      }, () => this.validate());
  };

  validators = {
    title: [v.NotNull],
  };

  validate = () => {
    const checks = [];
    if (Object.keys(this.validators).indexOf('title') > -1) {
      for (const validator of this.validators.title) {
        const check = validator(this.state.title);
        if (check) checks.push(check);
      }
    }
    this.setState({
      errors: {
        title: checks,
      },
    });
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  runExport = () => {
    const hasFieldErrors = this.haseErrors();
    if (!hasFieldErrors) {
      this.setState({ loading: true }, () => this.exportMapToPdf());
    }
  };

  filterPrintoutElements = element => {
    if (element instanceof HTMLImageElement) {
      if (element.src.startsWith('https://e-spdp.pl/oldihub/wmts')) {
        return true;
      }
      const allowedImagesClassNames = ['leaflet-tile'];
      return !allowedImagesClassNames.find(className =>
        element.classList.contains(className),
      );
    }
    return false;
  };

  exportMapToPdf = () => {
    const pixelToMM = 0.264583; // converting pixels to mm

    const input = document.getElementById('MapToPrint_PDF');
    html2canvas(input, {
      proxy: 'html2canvasProxy', // we need to use proxy server in node.js because of CORS policy html2canvasProxy is a url path to proxy
      useCORS: true,
      allowTaint: false,
      foreignObjectRendering: false,
      ignoreElements: e => this.filterPrintoutElements(e),
    })
    .then((canvas) => {
      const today = new Date();
      const imgData = canvas.toDataURL('image/jpeg');
      (function (JsPDFAPI) {
        const callAddFont = function () {
          this.addFileToVFS('My-font-normal.ttf', font);
          this.addFont('My-font-normal.ttf', 'My-font', 'normal');
        };
        JsPDFAPI.events.push(['addFonts', callAddFont]);
      }(JsPDF.API));
      const pdf = new JsPDF('p', 'mm', 'a4');
      pdf.setFont('My-font', 'normal');
      pdf.text(this.state.title, 10, 20, { maxWidth: 190 });
      pdf.addImage(imgData, 'JPEG', 10, 50, 190, 500 * pixelToMM);
      const printDate = today.toLocaleDateString("pl-PL", { // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      pdf.text(`Data wygenerowania wydruku: ${printDate}`, 105, 260, { maxWidth: 190, align: 'left' });
      pdf.save('wydruk.pdf');
      this.setState({ loading: false });
    });
  }

  render() {
    const loadingBody =
      (<div style={{ height: '100px', ...this.state.style }}>
        <center>
          <img role="presentation" src={waiting} style={{ width: '150px', height: '150px' }} />
        </center>
        <center>
          <p>
            Proszę czekać. Trwa generowanie wydruku.
          </p>
        </center>
      </div>);

    const loadingTitle = <p style={this.state.style}>Generowanie wydruku...</p>;
    return (
      <GrayPanel title={'Generowanie załącznika z mapy'}>
        <div className="row">
          <div className="col-sm-2">
            <p style={labelStyle}><b>{'Tytuł załącznika'}</b></p>
          </div>
          <div className={inputCol}>
            <input
              type="text"
              className="form-control"
              value={this.state.title}
              onChange={(e) => this.onChange(e)}
              style={{
                width: '100%',
                borderColor:
                  Object.keys(this.state.errors).indexOf('title') > -1 &&
                    this.state.errors.title !== null &&
                    this.state.errors.title.length > 0
                    ? 'red'
                    : '#ccc',
              }}
            />
            {/* RENDER ERROS IN SPAN */}
            {Object.keys(this.state.errors).indexOf('title') > -1 &&
              this.state.errors.title !== null &&
              this.state.errors.title.length > 0
              ? this.state.errors.title.map((val, index) => (
                <span key={index} style={errorSpanStyle}>
                  {val}
                </span>
              ))
              : null}
          </div>
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <button
              type="submit-lg"
              className={'btn btn-primary'}
              style={{ float: 'right', ...btnStyle }}
              onClick={() => this.runExport()}
            >
              Wygeneruj załącznik
          </button>
          </div>
        </div>
        <ModalAlert
          title={loadingTitle}
          bodyText={loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
          style={this.state.style}
        />
      </GrayPanel>
    );
  }

}

export default MapToPDF;



// WEBPACK FOOTER //
// src/components/MapToPDF/MapToPDF.js